<template>
  <div class="page__subtitle">
    2. Заполните поля основных сведений
  </div>
  <v-form ref="form">
    <div class="text_field__container">
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          :rules="[rules.name, rules.not_null]"
          v-maska:[name_options]
          v-model="data.last_name"
          :loading="loading"
          :error="hasError('last_name')"
          :error-messages="getError('last_name')"
      >
        <template v-slot:label>
          <div class="label__text">
            Фамилия
          </div>
        </template>
      </v-text-field>
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          :rules="[rules.name, rules.not_null]"
          v-maska:[name_options]
          v-model="data.name"
          :loading="loading"
          :error="hasError('name')"
          :error-messages="getError('name')"
      >
        <template v-slot:label>
          <div class="label__text">
            Имя
          </div>
        </template>
      </v-text-field>
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          :rules="[rules.middle_name]"
          v-maska:[name_options]
          v-model="data.middle_name"
          :loading="loading"
          :error="hasError('middle_name')"
          :error-messages="getError('middle_name')"
      >
        <template v-slot:label>
          <div class="label__text">
            Отчество
          </div>
        </template>
      </v-text-field>
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          v-model="data.phone"
          :rules="[rules.phone]"
          v-maska:[phone_options]
          :loading="loading"
          :error="hasError('phone')"
          :error-messages="getError('phone')"
      >
        <template v-slot:label>
          <div class="label__text">
            Телефон
          </div>
        </template>
      </v-text-field>
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          type="date"
          :min="'1900-01-01'"
          :max="'2500-12-31'"
          :rules="[rules.data, rules.not_null]"
          v-model="data.birth"
          :loading="loading"
          :error="hasError('birth')"
          :error-messages="getError('birth')"
      >
        <template v-slot:label>
          <div class="label__text">
            Дата рождения
          </div>
        </template>
      </v-text-field>
      <v-autocomplete
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          item-title="text"
          item-value="value"
          no-data-text="Нет подходящих данных"
          placeholder="Начните вводить назва..."
          :rules="[rules.not_null]"
          :items="selectors.regions"
          v-model="data.region"
          :loading="loading"
          :error="hasError('region')"
          :error-messages="getError('region')"
      >
        <template v-slot:label>
          <div class="label__text">
            Регион
          </div>
        </template>
      </v-autocomplete>
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          :rules="[rules.not_null]"
          v-model="data.city"
          :loading="loading"
          :error="hasError('city')"
          :error-messages="getError('city')"
      >
        <template v-slot:label>
          <div class="label__text">
            Населенный пункт
          </div>
        </template>
      </v-text-field>
      <div class="text__field" v-if="error">
        <v-alert
            class="error_alert"
            :value="true"
            outline
            :icon="false"
            color="#8f0808"
            variant="outlined"
        >
          {{ error }}
        </v-alert>
      </div>
      <v-btn
          class="btn__next"
          elevation="0"
          :loading="loading"
          @click="validate"
      >
        <span class="btn__next_text">
          ДАЛЕЕ
        </span>
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"
import { vMaska } from "maska"

export default defineComponent({
  name: "RegistrationMainInfo",
  mixins: [FormErrorsMixin],
  directives: { maska: vMaska },
  data () {
    return {
      phone_options: {
        mask: "+7 (###) ###-##-##",
        eager: true
      },
      name_options: {
        mask: "A-A",
        tokens: {
          A: { pattern: /^[а-яёА-ЯЁ]*$/, multiple: true },
        }
      },
      data: {
        last_name: undefined,
        name: undefined,
        middle_name: '',
        phone: '',
        birth: undefined,
        city: undefined,
        region: undefined,
      },
      selectors: {
        regions: [],
      },
      loading: false,
      type_date: false,
      error: null,
      rules: {
        name: value => {
          if (value !== undefined) {
            const pattern = /^[а-яёА-ЯЁ]+(?:[-/][а-яёА-ЯЁ]+)*$/
            return pattern.test(value) || 'Некорректный ввод'
          } else {
            return 'Обязательное поле'
          }
        },
        middle_name: value => {
          if (value !== '') {
            const pattern = /^[а-яёА-ЯЁ]+(?:[-/][а-яёА-ЯЁ]+)*$/
            return pattern.test(value) || 'Некорректный ввод'
          }
        },
        phone: value => {
          if (value !== '') {
            const pattern = /^\+7[ ]\(\d{3}\)[ ]\d{3}-\d{2}-\d{2}$/
            return pattern.test(value) || 'Некорректный ввод'
          }
        },
        data: value => {
          if (value !== undefined) {
            const pattern = /^\d{4}-\d{2}-\d{2}$/
            return pattern.test(value) || 'Некорректный ввод'
          } else {
            return 'Обязательное поле'
          }
        },
        not_null: value => {
          if (value !== undefined) {
            return (value !== null && value.toString().trim().length > 0) || 'Поле не может быть пустым'
          } else {
            return 'Обязательное поле'
          }
        },
      }
    }
  },
  watch: {
    data: {
      handler: function () {
        this.errors = {
          fields: {},
          non: []
        }
        this.error = null
      },
      deep: true
    }
  },
  computed: {
    pa_names () {
      return pa_names
    },
    names () {
      return names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      getUserStatus: 'auth/getUserStatus',
    })
  },
  methods: {
    ...mapActions({
      createMember: 'personal_account/members/createMember',
      loadScienceIdInfo: 'personal_account/science_id/loadScienceIdInfo',
      loadPreviousMembers: 'personal_account/members/loadPreviousMembers',
      loadRegions: 'selectors/loadRegions',
    }),
    endRedirect () {
      if (window.scrollY !== 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      if (this.getUserStatus.is_active_simplified) {
        this.$router.push({ name: names.REGISTRATION_INDIVIDUAL.PAGE, query: { type: this.$route.query.type, simplified: 'true' } })
      } else {
        this.$router.push({ name: names.REGISTRATION_INDIVIDUAL.PAGE, query: { type: this.$route.query.type } })
      }
    },
    async validate () {
      const { valid } = await this.$refs.form.validate()

      if (valid) {
        this.sendCreateMember()
      }
    },
    async loadSelectors () {
      await this.loadRegions({
        url: undefined,
        finalizer: (val) => {
          this.selectors.regions = val
        }
      })
    },
    getScienceIdData: function () {
      this.loading = true
      this.error = null
      this.loadScienceIdInfo(
        {
          finalizer: (data) => {
            this.loading = false
            this.error = null
            for (const key of Object.keys(data)) {
              // eslint-disable-next-line
              if (this.data.hasOwnProperty(key)) {
                this.data[key] = data[key]
              }
            }
          },
          catcher: (error) => {
            this.loading = false
            this.mapErrors(error)
          }
        }
      )
    },
    loadData (url = undefined) {
      this.loadPreviousMembers({
        url: url,
        finalizer: (data) => {
          for (const key of Object.keys(data)) {
            // eslint-disable-next-line
            if (this.data.hasOwnProperty(key)) {
              this.data[key] = data[key]
            }
          }

          this.selectors.regions.forEach((el) => {
            if (el.text === this.data.region) {
              this.data.region = el.value
            }
          })
        },
        catcher: () => {
          this.$router.push({ name: names.REGISTRATION.PAGE })
        }
      })
    },
    sendCreateMember: function () {
      this.loading = true
      this.error = null
      this.createMember(
        {
          data: this.data,
          finalizer: () => {
            this.loading = false
            this.error = null
            this.endRedirect()
          },
          catcher: (error) => {
            this.loading = false
            if (error.detail) {
              this.error = error.detail
            } else {
              this.mapErrors(error)
            }
          }
        }
      )
    },
  },
  created () {
    if (this.getUserStatus.member && !this.getUserStatus.is_not_valid) {
      this.$router.push({ name: pa_names.MAIN })
    } else {
      if (this.selectors.regions.length === 0) {
        this.loadSelectors()
      }
      if (this.getUserStatus.from_science_id) {
        this.getScienceIdData()
      } else if (this.getUserStatus.has_previous) {
        this.loadData()
      }
    }
  },
})
</script>

<style scoped lang="scss">
.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

.text_field__container {
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  width: 500px;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 50px;
  width: 200px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.text__field {
  margin: 0 auto 20px;
  width: 100%;
}

.v-field__field:hover {
  .label__text {
    color: black;
  }
}

.label__text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  text-align: center;

  color: #313743;
}

.error_alert {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: #8f0808;
  margin-bottom: 20px;
}

@media screen and (max-width: 1920px) {
  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }

  .text__field {
    margin-bottom: 10px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1279px) {
  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }
}

@media screen and (max-width: 768px) {
  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .text_field__container {
    width: 400px;
  }

  .label__text {
    font-size: 16px;
    line-height: 20px;
  }

  .btn__next {
    height: 55px;
    margin-bottom: 20px;
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }
}

@media screen and (max-width: 600px) {
  .text_field__container {
    width: 270px;
  }

  .text__field {
    margin-bottom: 8px;
  }
}
</style>
